import React, {Component} from 'react'
import ConfigurationsAPIService from '../../api-services/ConfigurationsAPIService'
import ProjectAPIService from '../../api-services/ProjectApiService'
import APIServicesRegistry from '../../api-services/APIServicesRegistry'
import Modal from '../common/Modal';
import ProjectStore from '../../store/projectStore'
import {observer} from 'mobx-react';
import ModalIndexPage from '../index-table/ModalIndexPage';
import Button from '../common/Button';
import Loader from '../common/Loader';

const AddExistingConfigurationModal = observer(
    class AddExistingConfigurationModal extends Component {

        state = {
            index: null,
            selected: [],
            rootCheckboxSelected: false,
            loading: false,
            adding: false
        }

        componentDidMount() {
            scheduleAtDocumentReady(() => {
                this.configurationsApiService = APIServicesRegistry.getService(ConfigurationsAPIService);
                this.projectApiService = APIServicesRegistry.getService(ProjectAPIService);
                this.initConfigurations();
            });
        }

        initConfigurations() {
            this.configurationsApiService.indexExternal().then(result => {
                this.setState({
                    index: result.data
                });
            });
        }

        onConfigurationCheckboxClick = manuallyChangedRows => {
            let ids = []
            for (let [k, v] of Object.entries(manuallyChangedRows)) {
                if (v) {
                    ids.push(parseInt(k))
                }
            }

            this.setState({
                selected: ids
            });
        }

        multiSelectRows = () => true;

        onRootConfigurationCheckboxToggle = () => {
            if (this.state.rootCheckboxSelected) {
                this.setState({selected: []});
            } else {
                this.setState({selected: this.state.index.results.map(x => x.id)});
            }

            this.setState({rootCheckboxSelected: !this.state.rootCheckboxSelected});
        }

        onAddConfigurationsClick = () => {
            this.setState({
                adding: true
            });
            var model = ProjectStore.getTransformedFormModel()
            var data = {
                ids: this.state.selected,
                projectId: ProjectStore.formModel.id.value,
                items: model.configurations,
                summary: model.summary
            }

            this.projectApiService.getConfigurationCollection(data).then(response => {
                ProjectStore.setAddExistingConfigurationModalVisible(false);
                if (response.data.items.items.length)
                    ProjectStore.setDirty(true);

                ProjectStore.updateConfigurationItems(response.data.items.items);
                ProjectStore.updateConfigurationSummary(response.data.summary);

                this.setState({
                    adding: false
                });
            });
        }

        onModelCloseRequest = () => {
            ProjectStore.setAddExistingConfigurationModalVisible(false);
        }

        renderModalBody() {
            const {columns, filter, paging, options, orderOptions} = this.state.index;
            let results = this.state.index.results;

            // Remove configurations that have already been to the project from the list.
            //let selectedConfigurations = ProjectStore.formModel.configurations.items.map(x => x.id);
            //results = results.filter(x => !selectedConfigurations.includes(x.id));

            return (
                <ModalIndexPage
                    columns={columns}
                    filter={filter}
                    results={results}
                    paging={paging}
                    options={options}
                    orderOptions={orderOptions}
                    onRowCheckboxToggled={this.onConfigurationCheckboxClick}
                    onRootCheckboxToggled={this.onRootConfigurationCheckboxToggle}
                    multiSelectRows={this.multiSelectRows}
                    indexApiService={ConfigurationsAPIService}
                    renderActionButtons={this.renderActionButtons}
                />
            )
        }

        renderLoader() {
            return (
                <Loader fillContainer={true}/>
            )
        }

        render() {
            return (
                <Modal isOpen={ProjectStore.addExistingConfigurationModalVisible} onClose={this.onModelCloseRequest}
                       width="auto">
                    <Modal.Header>{__('Configurations')}</Modal.Header>
                    <Modal.Body>
                        <div style={{position: 'relative'}}>
                            {this.state.index ? (
                                this.renderModalBody()
                            ) : (
                                this.renderLoader()
                            )}
                        </div>
                    </Modal.Body>
                </Modal>
            )
        }

        renderActionButtons = () => (
            this.state.index && (
                <div className="index-modal-button-actions">
                    <Button onClick={this.onModelCloseRequest}>{__('Cancel')}</Button>
                    <Button disabled={this.state.adding}
                            onClick={this.onAddConfigurationsClick}>{__(this.state.adding ? 'Adding...' : 'Add')}</Button>
                </div>

            )
        )
    }
)

export default AddExistingConfigurationModal